

const _sorted_redosled_draftelschemakey = [
  "terkk$klimakomora",
  "terkk$modul",
  // Delovi modula
  "terkk$modul$rogalj",
  "terkk$modul$profilosnovni",
  "terkk$modul$profilpregradni",
  "terkk$_bundle_panel", "terkk$panel",
  "terkk$demper",
  "terkk$elasticnaveza",
  "terkk$_bundle_eliminatorkapi", "terkk$eliminatorkapi",
  "terkk$spoljnafiksnazaluzina",
  // Abecedni deo redosleda Ispod SFZ a iznad postolja idemo za sve nove pp.
  "terkk$kadica",
  "terkk$kadica_v2", // v2
  "terkk$_bundle_klizac",
  "terkk$_bundle_klizacramamraztermostata", // // OBSOLETE
  // PPGRUPA RMT - VAZNO NE KORISTI SE OVAJ klizacramamraztermostata jer je on sada u sastavu PPGRUPA RMT
  "terkk$_bundle_kucisteelektrogrejaca", "terkk$kucisteelektrogrejaca",
  "terkk$_bundle_npr",
  "terkk$_bundle_nrr",
  "terkk$_bundle_nosacventilatora",
  "terkk$_bundle_parniovlazivac", "terkk$parniovlazivac",
  "terkk$_bundle_ppd", "terkk$ppd",
  "terkk$_bundle_ppv", "terkk$ppv",
  "terkk$_bundle_prigusivacbuke", "terkk$prigusivacbuke",
  // TODO ovde treba dodati i dva nova virtela koji su posebni poluproizvodi u grupi prigusivac buke
  "terkk$_bundle_protivkisnazaluzina", "terkk$protivkisnazaluzina",
  "terkk$_bundle_ramfiltera", "terkk$ramfiltera",
  "terkk$_bundle_ramfilteranauklizavanje",
  "terkk$_bundle_rammraztermostata", "terkk$rammraztermostata",
  "terkk$_bundle_usmerivacvazduha", "terkk$usmerivacvazduha",
  // Zadnji deo redosleda pocinje od postolja.
  "terkk$_bundle_postolje", "terkk$postolje$profil",
  "terkk$_bundle_krov", "terkk$krov$child",
  "terkk$_bundle_paletapakovanja", "terkk$paletapakovanja",
  "terkk$_bundle_limcustom", "terkk$limcustom",
  "terkk$_bundle_profilcustom", "terkk$profilcustom",
  "terkk$materijalcustom",
  "expt$sketch",
];
/*
- prva ide klima komora pa onda modul
- posle modula ide njegov rogalj pa njegovi profili
- prvi nakon modulovih profila je panel jer su paneli sledeci posle profila modula koji prakticno cini modul
- zatim prvobitno dodati poluproizvvodi idu abecednim redom zakljucno sa SFZ
- nakon SFZ svi noviji poluproizvodi koji su pre postolja takodje idu abecednim redosledom.
- PITANJE da li postolje da ide na kraju pre krova ili mozda na pocetku nakon panela??? Za sada je logicno da ide na kraj jer posle panela odavno su bili rasporedjeni neki stariji poluproizvodi.
- pre palete ide krov jer logicno da je krov posle postolja jer tokom sastavljanja mora da se stavi postolje da bi se postavio modul a tek kad postoji modul, moze da se monrira krov na njega
- predzadnji poluproizvod je paleta jer je ona prakticno ambalaza
- na kraju ide custom materijal a pre njega custom poluproitzvodi (custom lim i custom profil)
*/

//
export const terUtilsSortirajDrafteleKonzistentnimRedosledom = (draftel_arr) => {
  // NAPOMENA: Ova funkcija nije predvidjena da sortira ceo draftel_arr nego arr sa draftelima koji su profiltrirani tako da predstavljaju delove jednog modula na primer.
  // p._draftelschemakey
  const _get_sorting_index = (key) => {
    // return _sorted_redosled_draftelschemakey.indexOf(key);
    const index = _sorted_redosled_draftelschemakey.indexOf(key);
    if (index < 0) {
      // index not found
      return 99; // big index to be put on end of array
    } else {
      return index;
    }
  };
  const sortedArr = draftel_arr.sort(function (a, b) {
    // if (a._draftelschemakey > b._draftelschemakey) {
    if (_get_sorting_index(a._draftelschemakey) > _get_sorting_index(b._draftelschemakey)) {
      return 1;
    }
    // if (a._draftelschemakey < b._draftelschemakey) {
    if (_get_sorting_index(a._draftelschemakey) < _get_sorting_index(b._draftelschemakey)) {
      return -1;
    }
    return 0;
  });
  return sortedArr;
};


/*
//
const _ter_draftel_recnik = {
  "terkk$klimakomora": {
    "smartel_title": "Klima komora"
  },
  "terkk$modul": {
    "smartel_title": "Modul"
  },
  "terkk$modul$rogalj": {
    "smartel_title": "" // NE POJAVLJUJE SE KAO SMARTEL
  },
  "terkk$modul$profilosnovni": {
    "smartel_title": "" // NE POJAVLJUJE SE KAO SMARTEL
  },
  "terkk$modul$profilpregradni": {
    "smartel_title": "" // NE POJAVLJUJE SE KAO SMARTEL
  },
  "terkk$_bundle_panel": {
    "smartel_title": "Panel"
  },
  "terkk$panel": {
    "smartel_title": "" // OVO NIJE BUNDLE
  },
  "terkk$demper": {
    "smartel_title": "Demper"
  },
  "terkk$elasticnaveza": {
    "smartel_title": "Elastična veza (ELV)"
  },
  "terkk$_bundle_eliminatorkapi": {
    "smartel_title": "Eliminator kapi (ELK)"
  },
  "terkk$eliminatorkapi": {
    "smartel_title": "" // OVO NIJE BUNDLE
  },
  "terkk$spoljnafiksnazaluzina": {
    "smartel_title": "Spoljna fiksna žaluzina"
  },
  // Abecedni deo redosleda Ispod SFZ a iznad postolja idemo za sve nove pp.
  "terkk$kadica": {
    "smartel_title": "Kadica"
  },
  "terkk$_bundle_klizac": {
    "smartel_title": "Klizač"
  },
  "terkk$_bundle_klizacramamraztermostata": {
    "smartel_title": "Klizač Rama Mraz Termostata"
  },
  "terkk$_bundle_kucisteelektrogrejaca": {
    "smartel_title": "Kućište elektro grejača"
  },
  "terkk$_bundle_npr": {
    "smartel_title": "Nosač pločastog rekuperatora (NPR)"
  },
  "terkk$_bundle_nrr": {
    "smartel_title": "Nosač rotacionog rekuperatora (NRR)"
  },
  "terkk$_bundle_nosacventilatora": {
    "smartel_title": "Nosač ventilatora"
  },
  "terkk$_bundle_parniovlazivac": {
    "smartel_title": "Parni ovlaživač (POV)"
  },
  "terkk$_bundle_ppd": {
    "smartel_title": "PPD"
  },
  "terkk$_bundle_ppv": {
    "smartel_title": "PPV"
  },
  "terkk$_bundle_prigusivacbuke": {
    "smartel_title": "Prigušivač buke"
  },
  "terkk$_bundle_protivkisnazaluzina": {
    "smartel_title": "Protiv Kišna Žaluzina (PKZ)"
  },
  "terkk$_bundle_ramfiltera": {
    "smartel_title": "Ram filtera"
  },
  "terkk$_bundle_ramfilteranauklizavanje": {
    "smartel_title": "Ram filtera na uklizavanje"
  },
  "terkk$_bundle_rammraztermostata": {
    "smartel_title": "Ram mraz termostata (RMT)"
  },
  "terkk$_bundle_usmerivacvazduha": {
    "smartel_title": "Usmerivač vazduha"
  },
  //
  // Zadnji deo redosleda pocinje od postolja.
  "terkk$_bundle_postolje": {
    "smartel_title": "Postolje modula"
  },
  "terkk$_bundle_krov": {
    "smartel_title": "Krov"
  },
  "terkk$_bundle_paletapakovanja": {
    "smartel_title": "**** Paleta pakovanja"
  },
  "terkk$profilcustom": {
    "smartel_title": "Profil custom"
  },
  "terkk$limcustom": {
    "smartel_title": "Lim custom"
  },
  "terkk$_bundle_limcustom": {
    "smartel_title": "Lim CUSTOM"
  },
  "terkk$_bundle_profilcustom": {
    "smartel_title": "Profil CUSTOM"
  },
  "terkk$materijalcustom": {
    "smartel_title": "Materijal custom"
  },
  // experimental
  "zzkitc$kitc": {
    "smartel_title": "K"
  },
  "zzkitc$kitc$element": {
    "smartel_title": "Element"
  },
};


//
export const _get_draftel_recnik_item = (_draftelschemakey) => {
  if (_ter_draftel_recnik[_draftelschemakey]) {
    return _ter_draftel_recnik[_draftelschemakey];
  }
  return {
    "smartel_title": _draftelschemakey
  };
};
*/

